function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.641 15.39l1.432 1.473a.065.065 0 00.01.009l.008.006-5.54 5.627c-.65.66-1.707.66-2.358 0-.03-.032-8.207-8.336-8.207-8.336a3.45 3.45 0 010-4.829L3.29 7a3.332 3.332 0 014.76 0l2.322 2.355L12.693 7a3.332 3.332 0 014.76 0l2.3 2.334-4.102 4.136a1.375 1.375 0 00-.01 1.92zm7.657-7.713L30 14.435l-1.452 1.473-4.233-4.294v11.368H22.28V11.614l-4.253 4.294-1.432-1.473 6.702-6.758z",
  fill: "currentColor"
})));